import {
  Badge,
  IconButton,
  ListItemIcon,
  Menu,
  MenuItem,
} from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import { Search } from '@material-ui/icons';
import BugReportIcon from '@material-ui/icons/BugReport';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ForumIcon from '@material-ui/icons/ForumRounded';
import MenuIcon from '@material-ui/icons/Menu';
import NotificationsIcon from '@material-ui/icons/NotificationsRounded';
import NotListedLocationIcon from '@material-ui/icons/NotListedLocation';
import Settings from '@material-ui/icons/SettingsRounded';
import {
  getInfoAccountByAlias,
  getInfosBusiness,
  getInfosIndividual,
  getInfosSchool,
  getInfosCFA,
  getNotifications,
  getProfilePresentation,
  getDefaultTeamMembersByBusiness,
} from '@webapps/business';
/* eslint-disable no-nested-ternary */
import {
  Button,
  Modal,
  ModalSidebarMenu,
  useAuth,
  useNotif,
  useQuery,
  useRouter,
  useStrophe,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import history from 'components/History';
import HubspotContactForm from 'components/HubspotContactForm';
import StarIcon from 'components/Icons/Star';
import {
  ROUTES_PATH,
  businessMenu,
  businessMenuFree,
  cfaMenu,
  schoolMenu,
  schoolMenuFree,
  studentMenu,
} from 'config/constants';
import React, { createContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link, NavLink, useHistory, useLocation } from 'react-router-dom';

import Mapimg from '../../../../../libs/styles/src/lib/assets/images/map';
import theme from './theme';
import HeaderPage from 'components/HeaderPage';

const {
  colors: { itemActive, primaryColor },
  images: { PicsMap, PicsLogo, PicsMapWhite },
} = theme;

const Header = () => {
  const {
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const [isShown, setIsShown] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobAnchorEl, setMobAnchorEl] = React.useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [openModal2, setOpenModal2] = useState(false);
  const [openForm, setOpenForm] = useState(false);
  const [formType, setFormType] = useState('');
  const [formId, setFormId] = useState('');
  const [badgeCount, setBadgeCount] = useState(null);
  const open = Boolean(anchorEl);
  const [openMob, setOpenMob] = useState(false); //Boolean(mobAnchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickMob = (event) => {
    setOpenMob(true);
  };

  const handleCloseMob = () => {
    setOpenMob(false);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleMobClose = () => {
    setMobAnchorEl(null);
  };

  const history = useHistory();
  const { classes, css } = useStyles(styles);
  const { userAlias, idUser, logout, profile } = useAuth();
  const { pathname } = useLocation();
  const { totalNotif } = useNotif();
  const { disconnect, messagesReceived } = useStrophe();

  const { push } = useRouter();
  const handleLogOutOnClick = () => {
    disconnect();
    logout();
  };

  const { data: { profileImageUrl = '', completeRate } = {}, refetch } =
    useQuery(getProfilePresentation, {
      key: 'coverImageMenu',
      variables: { id: idUser },
    });

  const { data: { content: notifs = [], totalElements } = {} } = useQuery(
    getNotifications,
    {
      key: ['notifsStudent', idUser],
      variables: {
        id: idUser,
        page: 0,
        size: 8,
        status: 'unread',
      },
      keepPreviousData: true,
      staleTime: 5000,
    }
  );

  const { data: infos = [] } = useQuery(getInfoAccountByAlias, {
    key: ['profilInfo', userAlias],
    variables: { alias: userAlias },
  });

  const { data: infoDefaultTeam = "fetching" } = useQuery(getDefaultTeamMembersByBusiness, {
    key: ['defaultTeam', idUser],
    variables: { id: idUser },
  });

  const [menu, setMenu] = useState([]);

  useEffect(() => {
    if (
      profile === 'SCHOOL' &&
      (infos?.subscription === 'premium' || infos?.subscription === 'Premium')
    ) {
      setMenu(schoolMenu);
    } else if (
      profile === 'BUSINESS' &&
      (infos?.subscription === 'premium' || infos?.subscription === 'Premium')
    ) {
      setMenu(businessMenu);
    } else if (profile === 'INDIVIDUAL') {
      setMenu(studentMenu);
    } else if (
      profile === 'SCHOOL' &&
      (infos?.subscription === 'free' || infos?.subscription === null)
    ) {
      setMenu(schoolMenuFree);
    } else if (
      profile === 'BUSINESS' &&
      (infos?.subscription === 'free' || infos?.subscription === null)
    ) {
      setMenu(businessMenuFree);
    } else if (profile === 'CFA') {
      setMenu(cfaMenu);
    }
  }, [pathname, infos, infoDefaultTeam]);
  
  const handleMyMap = async () => {
    await refetch();
    if (profile === 'INDIVIDUAL' && completeRate !== 100) {
      setOpenModal(true);
      push(ROUTES_PATH.STUDENT_PROFIL);
      return;
    }
    else{
      push(profile === 'INDIVIDUAL' ? ROUTES_PATH.MYMAP : profile === 'SCHOOL' ? ROUTES_PATH.MAP_SCHOOL : profile === "BUSINESS" ? ROUTES_PATH.MAP_BUSINESS : ROUTES_PATH.MAP_CFA)
    }
  };

  const handleOpenCreateAnnonce = () => {
    setOpenCreateAnnonce(true);
  };

  const { data: infosStudent = {}, isLoading } = useQuery(getInfosIndividual, {
    key: 'indivudualInfos',
    variables: { id: idUser },
  });

  const { data: infosSchool = {}, isLoading1 } = useQuery(getInfosSchool, {
    key: 'schoolInfos',
    variables: { id: idUser },
  });

  const { data: infosBusiness = {}, isLoading2 } = useQuery(getInfosBusiness, {
    key: 'businessInfos',
    variables: { id: idUser },
  });

  const { data: infosCFA = {}, isLoading3 } = useQuery(getInfosCFA, {
    key: 'cfaInfos',
    variables: { id: idUser },
  });

  const handleParameters = () => {
    profile === 'INDIVIDUAL' ? push(ROUTES_PATH.STUDENT_SETTINGS)
    : profile === 'SCHOOL' ? push(ROUTES_PATH.SCHOOL_SETTINGS )
    : profile === 'BUSINESS' ? push(ROUTES_PATH.BUSINESS_SETTINGS)
    : push(ROUTES_PATH.CFA_SETTINGS)
  }

  useEffect(() => {
    setBadgeCount(messagesReceived?.length);
  }, [messagesReceived]);

  return (
    <>
      <div className={classes.header}>
        <div>
          <div className={classes.where}>
            <HeaderPage />
          </div>
        </div>
        <div className={global.frac} style={{ gap: 10 }}>
          <div>
            {pathname !== '/apprenant/ma-recherche' &&
              pathname !== '/entreprise/ma-recherche' &&
              pathname !== '/etablissement/ma-recherche' ? (
              <div>
                <Button
                  className={classes.btnRecherche}
                  variant="outlined"
                  onMouseEnter={() => setIsShown(true)}
                  onMouseLeave={() => setIsShown(false)}
                  onClick={() => {
                    handleMyMap();
                    setIsShown(false);
                  }}
                >
                  <Mapimg
                    fill={isShown ? '#FFFFFF' : '#0060f9'}
                    height={30}
                    width={30}
                  />
                  <span style={{ marginLeft: spacing(1) }}>
                    {' '}
                    Rechercher des offres{' '}
                  </span>
                </Button>
              </div>
            ) : null}
          </div>
          <Modal
            title="Comment devenir visible et candidater aux offres"
            titleFontSize="20px"
            className={css({ width: '50%' })}
            open={openModal}
            width={'400px'}
            onCancel={() => setOpenModal(false)}
          >
            <div className={classes.modal}>
              <div className={classes.modalTitle}>
                Profil incomplet : Restriction
              </div>
              <div className={classes.modalText}>
                Un profil incomplet empêche l'accès à l'onglet "Postuler" pour
                trouver des offres de formations et d'emploi.
              </div>
              <div className={classes.modalText}>
                Compléter le profil est essentiel pour des suggestions pertinentes
                et personnalisées, en alignant les opportunités avec vos
                compétences et aspirations.
              </div>
              <div className={classes.modalText}>
                Afin d'obtenir un profil complet, veuillez au moins remplir ces
                sections dans votre profil :
              </div>
              <div>
                <li className={classes.modalList}>Présentation</li>
                <li className={classes.modalList}>Critères de recherche</li>
                <li className={classes.modalList}>Formation</li>
              </div>
            </div>
          </Modal>
          <div>
            {profile === 'BUSINESS' &&
              pathname !== ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS &&
              pathname !== ROUTES_PATH.BUSINESS_DASHBOARD ? (
              <div>
                <Button
                  style={{ boxShadow: 'none' }}
                  color="primary"
                  onClick={() => {
                    history.push(ROUTES_PATH.BUSINESS_ANNONCES_CANDIDATS, {
                      openCreateAnnonce: true,
                    });
                  }}
                  variant="contained"
                >
                  <FormattedMessage id="business.annoncesCandidats.btnPublierAnnonce" />
                </Button>
              </div>
            ) : null}

          </div>
          <div>
            {profile === 'SCHOOL' &&
              pathname !== ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS &&
              pathname !== ROUTES_PATH.SCHOOL_DASHBOARD ? (
              <div>
                <Button
                  style={{ boxShadow: 'none' }}
                  color="primary"
                  onClick={() => {
                    history.push({
                      pathname: ROUTES_PATH.SCHOOL_FORMATIONS_CANDIDATS,
                      state: { openCreateFormation: true },
                    });
                  }}
                  variant="contained"
                >
                  <FormattedMessage id="school.formationsCandidats.btnPublierFormation" />
                </Button>
              </div>
            ) : null}
          </div>
          <div>
            <Link
              className={css({ textDecoration: 'none' })}
              to={
                profile === 'INDIVIDUAL'
                  ? ROUTES_PATH.STUDENT_NOTIFICATIONS
                  : profile === 'SCHOOL'
                    ? ROUTES_PATH.SCHOOL_NOTIFICATIONS
                    : profile === 'BUSINESS'
                      ? ROUTES_PATH.BUSINESS_NOTIFICATIONS
                      : ROUTES_PATH.CFA_NOTIFICATIONS
              }
            >
              <div>
                {notifs.length ? (
                  <Badge
                    badgeContent=''
                    color="secondary"
                    className={classes.badge}
                  >
                    <IconButton className={classes.btn}>
                      <NotificationsIcon style={{ fontSize: '24' }} />
                    </IconButton>
                  </Badge>
                ) : (
                  <IconButton className={classes.btn}>
                    <NotificationsIcon style={{ fontSize: '24' }} />
                  </IconButton>
                )}
              </div>
              {/* <div>
              <IconButton className={classes.btn}>
                <NotificationsIcon style={{ fontSize: '30' }} />
              </IconButton>
            </div> */}
            </Link>
          </div>
          <div>
            <Link
              className={css({ textDecoration: 'none' })}
              to={
                profile === 'INDIVIDUAL'
                  ? ROUTES_PATH.STUDENT_MESSAGES
                  : profile === 'SCHOOL'
                    ? ROUTES_PATH.SCHOOL_MESSAGES
                    : profile === 'BUSINESS'
                      ? ROUTES_PATH.BUSINESS_MESSAGES
                      : ROUTES_PATH.CFA_MESSAGES
              }
            >
              <div>
                {badgeCount ? (
                  <Badge
                    badgeContent=''
                    color="secondary"
                    className={classes.badge}
                  >
                    <IconButton className={classes.btn}>
                      <ForumIcon style={{ fontSize: '24' }} />
                    </IconButton>
                  </Badge>
                ) : (
                  <IconButton className={classes.btn}>
                    <ForumIcon style={{ fontSize: '24' }} />
                  </IconButton>
                )}
              </div>
            </Link>
          </div>

          <div className={classes.btnSettingContainer}>
            <IconButton
              onClick={handleClick}
              size="small"
              aria-controls={open ? 'account-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={open ? 'true' : undefined}
            >
              {profileImageUrl ? (
                <Avatar className={classes.avatar} src={profileImageUrl} />
              ) : (
                <Avatar className={classes.avatar}>
                  {profile === 'INDIVIDUAL'
                    ? infosStudent?.firstname?.substr(0, 1) +
                    infosStudent?.lastname?.substr(0, 1)
                    : profile === 'SCHOOL'
                      ? infosSchool?.name?.substr(0, 1)
                      : profile === 'BUSINESS'
                        ? infosBusiness?.name?.substr(0, 1)
                        : infosCFA?.name?.substr(0, 1)}
                  <div className={css({ display: 'none' })}>Nom</div>
                </Avatar>
              )}
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={open}
              onClose={handleClose}
              onClick={handleClose}
              PaperProps={{ elevation: 2 }}
              transformOrigin={{ horizontal: 'left', vertical: -60 }}
              anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            >
              <MenuItem onClick={handleParameters}>
                <ListItemIcon>
                  <Settings fontSize="small" className={classes.icon} />
                </ListItemIcon>
                <span style={{ color: '#5A6DA1' }}>Paramètres</span>
              </MenuItem>
              {/*
            <MenuItem onClick={() => { setOpenForm(true); setFormType("bug") }}>
              <ListItemIcon>
                <BugReportIcon fontSize="small" className={classes.icon} />
              </ListItemIcon>
              <span style={{ color: '#5A6DA1', }}>Signaler un bug</span>
            </MenuItem>
            <MenuItem onClick={() => { setOpenForm(true); setFormType("suggestion") }}>
              <ListItemIcon>
                <EmojiObjectsIcon fontSize="small" className={classes.icon} />
              </ListItemIcon>
              <span style={{ color: '#5A6DA1', }}>Suggérer une idée</span>
            </MenuItem>
                      */}
              <MenuItem onClick={handleLogOutOnClick}>
                <ListItemIcon>
                  <ExitToAppIcon fontSize="small" className={classes.icon} />
                </ListItemIcon>
                <span style={{ color: '#5A6DA1' }}>Déconnexion</span>
              </MenuItem>
            </Menu>
            <div></div>
          </div>
        </div>
      </div>

      {/* Mobile  */}

      <div className={classes.mobileOnly}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
          }}
        >
          <Link
            to={
              profile === 'INDIVIDUAL'
                ? ROUTES_PATH.STUDENT_DASHBOARD
                : profile === 'SCHOOL'
                  ? ROUTES_PATH.SCHOOL_DASHBOARD
                  : profile === 'BUSINESS'
                    ? ROUTES_PATH.BUSINESS_DASHBOARD
                    : ROUTES_PATH.CFA_DASHBOARD
            }
            style={{ display: 'flex', justifyContent: 'start' }}
          >
            <img alt="Linkpick" className={classes.logo} src={PicsLogo} />
          </Link>
          <div className={classes.headerMobile}>
            <div>
              <Link
                className={css({ textDecoration: 'none' })}
                to={
                  profile === 'INDIVIDUAL'
                    ? ROUTES_PATH.STUDENT_NOTIFICATIONS
                    : profile === 'SCHOOL'
                      ? ROUTES_PATH.SCHOOL_NOTIFICATIONS
                      : profile === 'BUSINESS' 
                        ? ROUTES_PATH.BUSINESS_NOTIFICATIONS
                        : ROUTES_PATH.CFA_NOTIFICATIONS
                }
              >
                <div>
                  {notifs.length ? (
                    <Badge
                      badgeContent=''
                      color="secondary"
                      className={classes.badge}
                    >
                      <IconButton className={classes.btn}>
                        <NotificationsIcon className={classes.headerIcon} />
                      </IconButton>
                    </Badge>
                  ) : (
                    <IconButton className={classes.btn}>
                      <NotificationsIcon className={classes.headerIcon} />
                    </IconButton>
                  )}
                </div>
              </Link>
            </div>
            <div>
              <Link
                className={css({ textDecoration: 'none' })}
                to={
                  profile === 'INDIVIDUAL'
                    ? ROUTES_PATH.STUDENT_MESSAGES
                    : profile === 'SCHOOL'
                      ? ROUTES_PATH.SCHOOL_MESSAGES
                      : profile === 'BUSINESS' 
                        ? ROUTES_PATH.BUSINESS_MESSAGES
                        : ROUTES_PATH.CFA_MESSAGES
                }
              >
                <div>
                  <IconButton className={classes.btn}>
                    <ForumIcon className={classes.headerIcon} />
                  </IconButton>
                </div>
              </Link>
            </div>
            <div className={classes.btnSettingContainer}>
              <IconButton onClick={handleClickMob} size="small">
                <MenuIcon htmlColor="#5A6DA1" />
              </IconButton>
              <ModalSidebarMenu
                displayTitle={false}
                handleClose={() => setOpenMob(false)}
                open={openMob}
                title=""
                width="80%"
              >
                {menu.map(({ icon: Icon, link, name, altLinks, disabled }) => (
                  <NavLink
                    key={link}
                    className={!disabled ? classes.item : classes.itemDisabled}
                    onClick={() => {
                      setOpenMob(false);
                      disabled && setOpenModal2(true);
                    }}
                    exact
                    replace={pathname === link}
                    to={!disabled && link}
                    isActive={() => link === pathname || altLinks?.includes(pathname)}
                  >
                    {Icon && (
                      <div className={classes.itemIcon}>
                        {disabled && <StarIcon className={classes.star} />}
                        <ListItemIcon>
                          <Icon className={classes.icon} />
                        </ListItemIcon>
                        <span style={{ fontSize: 18 }}> {name}</span>
                      </div>
                    )}
                  </NavLink>
                ))}

                <div style={{ bottom: 20 }}>
                  {/*
                <Link to='#' onClick={() => { setOpenForm(true); setFormType("bug") }} className={classes.item}>
                  <ListItemIcon>
                    <BugReportIcon fontSize="small" className={classes.icon} />
                  </ListItemIcon>
                  <span style={{ fontSize: 18 }}>Signaler un bug</span>
                </Link>
                <Link to='#' onClick={() => { setOpenForm(true); setFormType("suggestion") }} className={classes.item}>
                  <ListItemIcon>
                    <EmojiObjectsIcon fontSize="small" className={classes.icon} />
                  </ListItemIcon>
                  <span style={{ fontSize: 18 }}>Suggérer une idée</span>
                </Link>
                  */}
                  <Link
                    to="#"
                    onClick={handleLogOutOnClick}
                    className={cx(classes.item, classes.logoutItem)}
                  >
                    <ListItemIcon>
                      <ExitToAppIcon
                        fontSize="small"
                        className={classes.icon}
                      />
                    </ListItemIcon>
                    <span style={{ fontSize: 18 }}>Déconnexion</span>
                  </Link>
                </div>
              </ModalSidebarMenu>
              <Modal open={openForm} onCancel={() => setOpenForm(false)}>
                <HubspotContactForm
                  region="eu1"
                  portalId="26967904"
                  formId={formId}
                  type={formType}
                />
              </Modal>
              <div></div>
            </div>
          </div>
        </div>
        <Modal
          open={openModal2}
          onCancel={() => setOpenModal2(false)}
          title="Vous n'avez pas accès à cette fonctionnalité"
        >
          <div>
            <div className={classes.modalContentText}>
              Pour profiter pleinement de cette fonctionnalité, veuillez
              souscrire à l'offre adaptée <div />
              <div className={classes.modalContentButtons}>
                <Button
                  color="primary"
                  onClick={() => {
                    setOpenModal2(false);
                    profile === 'SCHOOL'
                      ? push(`${ROUTES_PATH.SCHOOL_SETTINGS}?subscribe=true`)
                      : push(`${ROUTES_PATH.BUSINESS_SETTINGS}?subscribe=true`);
                  }}
                  variant="contained"
                >
                  Voir les offres
                </Button>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

const styles = ({ spacing }) => ({
  header: {
    height: '65px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    columnGap: spacing(1),
    '@media only screen and (max-width:768px)': { display: 'none' },
  },
  mobileOnly: {
    display: 'none',
    '@media only screen and (max-width:768px)': {
      width: '100%',
      display: 'block',
      paddingLeft: spacing(2),
      paddingRight: spacing(2),
    },
  },
  headerMobile: {
    height: '10vh',
    display: 'flex',
    alignItems: 'center',
    columnGap: spacing(1),
    justifyContent: 'end',
  },
  btnSettingContainer: {
    '@media only screen and (min-width:768px)': {
      marginRight: spacing(6),
    },
  },
  btnRecherche: {
    borderRadius: '400px',
    background: '#F3F7FF',
    color: '#152652',
    border: '1px solid #C0D9FF',
    padding: spacing(1),
    paddingRight: spacing(2),
    paddingLeft: spacing(2),
    marginRight: spacing(1),
    '&:hover, &.active': {
      background: '#0060F9',
      color: 'white',
      border: '1px solid #0060F9',
    },
  },
  logo: {
    marginRight: spacing(1),
    width: 150,
    '@media only screen and (min-width:768px)': {
      marginLeft: 40,
    },
  },
  name: {
    display: 'flex ',
    flexDirection: 'row',
  },
  postanoffer: {
    borderRadius: '400px',
  },
  btn: {
    background: 'white',
    border: '0px solid black',
    color: '#0060F9',
    padding: spacing(1),
    '&:hover, &.active': {
      background: '#0060F9',
      color: 'white',
    },
  },
  icon: {
    '@media only screen and (max-width:1920px)': { fontSize: '26px' },
    '@media only screen and (max-width:1600px)': { fontSize: '22px' },
    color: '#5A6DA1',
    marginLeft: spacing(1.5),
    '&:hover, &.active': {
      fontWeight: 600,
      color: '#ffffff',
    },
  },
  headerIcon: {
    fontSize: '30px',
    '@media only screen and (max-width:768px)': { fontSize: '22px' },
  },
  item: {
    display: 'flex',
    width: '100%',
    height: 45,
    marginTop: spacing(0.5),
    alignItems: 'center',
    justifyContent: 'start',
    borderLeft: `5px solid #152652`,
    textDecoration: 'none',
    color: '#5A6DA1',
    fontWeight: 400,
    '&:hover, &.active': {
      fontWeight: 600,
      color: '#ffffff ! important',
      borderLeft: `5px solid ${primaryColor}`,
      icon: {
        color: 'white !important',
      },
    },
    '&:hover svg, &.active svg': {
      color: '#ffffff ! important',
    },
  },
  logoutItem: {
    '&:hover, &.active': {
      borderLeft: `5px solid #F50057`,
    },
  },
  itemDisabled: {
    display: 'flex',
    cursor: 'not-allowed',
    width: '100%',
    height: 45,
    marginTop: spacing(0.5),
    alignItems: 'center',
    justifyContent: 'start',
    borderLeft: `5px solid #152652`,
    textDecoration: 'none',
    color: '#5A6DA1',
    fontWeight: 400,
    itemIcon: {
      color: 'white',
    },
  },
  star: {
    position: 'absolute',
    width: '15px',
    top: '-10px',
    left: '10px',
  },
  modalContentText: {
    fontWeight: 400,
    textAlign: 'center',
    color: '#5D75A8',
    marginTop: spacing(1),
  },
  modalContentButtons: {
    display: 'flex',
    justifyContent: 'space-around',
    marginTop: spacing(2),
  },
  itemIcon: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
  },
  picsmap: {
    fill: '#0060f9',
    '&:hover': {
      fill: 'white',
    },
  },
  picsmapwhite: {
    opacity: 0,
    '&:hover': {
      opacity: 1,
    },
  },
  badge: {
    '.MuiBadge-anchorOriginTopRightRectangle': {
      transform: 'translate(70%, 60%)',
      right: '15px',
      height: '12px',
      width: '5px',
      minWidth: 'unset',
    },
    marginRight: spacing(1),
  },
  modalTitle: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    fontWeight: 'bold',
    color: '#152652',
    marginBottom: spacing(2),
    textAlign: 'center',
  },
  modalText: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    color: '#152652',
    marginBottom: spacing(2),
    textAlign: 'center',
  },
  modalList: {
    '@media only screen and (max-width:1920px)': { fontSize: '13.500px' }, '@media only screen and (max-width:1600px)': { fontSize: '13.5000px' },
    color: '#152652',
  },
  where: {
    marginLeft: '50px',
    '@media only screen and (max-width:1543px)': { marginLeft: '42px' },
    '@media only screen and (max-width:1440px)': { marginLeft: '34px' },
  },
});

export default Header;
